import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { buildQuery } from '../exports/queryStringBuilder'

import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-web-harvesting-bot-key'
const prefixKey = "ams-web-harvesting-bot-key";

const getSuffixKey = (obj) => `-${btoa(JSON.stringify(obj))}`;

const api = async (method, path, params) => axios[method](path, params)

const state = {
    item: null,
    query: '',
    items: [],
    filters: {},
    pagination: null,
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
    set_pagination(state, payload) {
        state.pagination = payload
    },

    SET_FILTERS(state, payload) {
        state.filters = payload
    },

    SET_QUERY(state, payload) {
        state.filters = payload
    },
}

const actions = {
    async create(context, payload) {
        try {
            // Mock data for demonstration
            const data = {
                id: Date.now(),
                ...payload,
                created_at: new Date().toISOString(),
                last_run_at: null,
                status: payload.status || 'active'
            }
            
            // Add to items array
            const currentItems = [...context.state.items]
            currentItems.push(data)
            context.commit('set_items', currentItems)
            context.commit('set_item', data)
            
            return data
        } catch (err) {
            errorHandler(err)
            throw err
        }
    },
    async fetchById(context, id) {
        try {
            await context.dispatch('fetchAll')
            context.commit(
                'set_item',
                context.state.items.find(x => x.id == id)
            )
        } catch (err) {
            errorHandler(err)
            throw err
        }
    },

    async fetchAll(
        { commit, state },
        { query, filters, page: page_no, per_page, isforcedReload }
    ) {
        try {
            // Mock data for demonstration
            const mockData = [
                {
                    id: 1,
                    name: 'Tech News Scraper',
                    url: 'https://techcrunch.com',
                    status: 'active',
                    ai_prompt: 'Extract the latest technology news headlines, publication dates, and article summaries from the homepage.',
                    search_keywords: 'news, tech, startup, innovation',
                    destination_type: 'google_drive',
                    google_drive_folder_id: '1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgvE2upms',
                    order_type_id: 1,
                    default_customer_id: 5,
                    rpa_template_id: 2,
                    requires_authentication: false,
                    authentication_type: 'basic_auth',
                    auth_username: '',
                    auth_password: '',
                    auth_login_url: '',
                    schedule_type: 'interval',
                    interval_value: 6,
                    interval_unit: 'hours',  
                    download_type: 'content',
                    last_run_at: '2024-01-15T10:30:00Z',
                    created_at: '2024-01-10T08:00:00Z'
                },
                {
                    id: 2,
                    name: 'Product Price Monitor',
                    url: 'https://example-store.com/products',
                    status: 'active',
                    ai_prompt: 'Monitor product prices and availability. Extract product names, current prices, original prices, and stock status.',
                    search_keywords: 'price, product, inventory, stock',
                    destination_type: 's3',
                    s3_bucket_name: 'company-data',
                    s3_folder_path: 'pricing/',
                    order_type_id: 2,
                    default_customer_id: 3,
                    rpa_template_id: 1,
                    requires_authentication: true,
                    authentication_type: 'form_login',
                    auth_username: 'demo_user',
                    auth_password: '••••••••',
                    auth_login_url: 'https://example-store.com/login',
                    schedule_type: 'interval',
                    interval_value: 12,
                    interval_unit: 'hours',
                    download_type: 'content',
                    last_run_at: '2024-01-16T09:00:00Z',
                    created_at: '2024-01-12T14:20:00Z'
                },
                {
                    id: 3,
                    name: 'Job Listings Collector',
                    url: 'https://jobs.example.com',
                    status: 'paused',
                    ai_prompt: 'Collect job postings for software developer positions. Extract job titles, company names, locations, salary ranges, and posting dates.',
                    search_keywords: 'developer, engineer, software, programming',
                    destination_type: 's3',
                    s3_bucket_name: 'company-data',
                    s3_folder_path: 'jobs/listings/',
                    order_type_id: 3,
                    default_customer_id: null,
                    rpa_template_id: 3,
                    requires_authentication: true,
                    authentication_type: 'basic_auth',
                    auth_username: 'api_user',
                    auth_password: '••••••••',
                    auth_login_url: '',
                    schedule_type: 'manual',
                    download_type: 'content',
                    last_run_at: null,
                    created_at: '2024-01-14T16:45:00Z'
                }
            ];
            
            // Filter by query if provided
            let filteredData = mockData;
            if (query) {
                filteredData = mockData.filter(item => 
                    item.name.toLowerCase().includes(query.toLowerCase()) ||
                    item.url.toLowerCase().includes(query.toLowerCase())
                );
            }
            
            commit("set_items", filteredData);
            commit("set_pagination", {
                page: 1,
                pageSize: per_page || 10,
                total: filteredData.length,
            });
            
            return {
                data: filteredData,
                pagination: {
                    total: filteredData.length,
                    current_page: 1,
                    per_page: per_page || 10
                }
            };
        } catch (err) {
            errorHandler(err);
            throw err;
        }
    },

    async update(context, payload) {
        try {
            // Mock update for demonstration
            const updatedData = {
                ...payload,
                updated_at: new Date().toISOString()
            }
            
            // Update in items array
            const currentItems = [...context.state.items]
            const index = currentItems.findIndex(item => item.id === payload.id)
            if (index !== -1) {
                currentItems[index] = updatedData
                context.commit('set_items', currentItems)
            }
            context.commit('set_item', updatedData)
            
            return updatedData
        } catch (err) {
            errorHandler(err)
            throw err
        }
    },

    async delete(context, id) {
        try {
            // Mock delete for demonstration
            const currentItems = [...context.state.items]
            const filteredItems = currentItems.filter(item => item.id !== id)
            context.commit('set_items', filteredItems)
            context.commit('set_item', null)
        } catch (err) {
            errorHandler(err)
            throw err
        }
    },

    async testRun(context, id) {
        try {
            // Mock test run for demonstration
            return {
                message: 'Test run started successfully',
                run_id: Date.now(),
                status: 'running'
            }
        } catch (err) {
            errorHandler(err)
            throw err
        }
    },

    async runBot(context, id) {
        try {
            const results = await api('post', `web-harvesting-bot/${id}/run`)
            return results.data.success?.data || results.data
        } catch (err) {
            errorHandler(err)
            throw err
        }
    },

    async getRunHistory(context, { id, page = 1, per_page = 10 }) {
        try {
            const results = await api('get', `web-harvesting-bot/${id}/runs?page=${page}&per_page=${per_page}`)
            return results.data.success?.data || results.data
        } catch (err) {
            errorHandler(err)
            throw err
        }
    },
}

const getters = {
    activeBots: state => state.items.filter(bot => bot.status === 'active'),
    botsByStatus: state => status => state.items.filter(bot => bot.status === status),
    getBotById: state => id => state.items.find(bot => bot.id === id),
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}